import sal from 'sal.js'
import windowed from './modules/window'

const BREAKPOINT = 640
const BREAKPOINT2 = 1200

const $ = jQuery
const $body = $('body')
const $modal = $('#modal')

$(() => {
  $('li.menu-item').each(function () {
    let $item = $(this);
    if (
      !$item.closest('.sub-menu, .nav\\:primary\\:\\:submenulist').length &&
      !$item.hasClass('menu-item-has-children')
    ) {
      $item.addClass('single-menu-item');
    }
  });
  $('body').on('keydown', function (e) {
    var keyCode = e.key || e.code;
    if (keyCode == 'Tab') {
      $('body').addClass('tab-pressed');
    }

    $(document).one('focusin', function () {
      let focusedElement = $(document.activeElement);
      let parentMenuItem = focusedElement.closest('li.menu-item');

      if (parentMenuItem.hasClass('menu-item-has-children')) {
        $('.menu-item-has-children').removeClass('menu-opened');
        parentMenuItem.addClass('menu-opened');
      }

      if (parentMenuItem.hasClass('single-menu-item')) {
        $('.menu-item-has-children').removeClass('menu-opened');
      }
    });
  });

  sal()

  new windowed

  $('[tabbed]').each((index, element) => {
    const $this = $(element)
    const $slides = $this.find('[tabbed\\@tabs]')
    const $links = $this.find('[tabbed\\@links] button')

    $slides.slick({
      arrows: false,
      slidesToShow: 1,
      draggable: false,
      responsive: [{
        breakpoint: BREAKPOINT,
        settings: {
          dots: true
        }
      }]
    })

    // Set tabindex=0 on links
    $links.each((index, element) => {
      const $this = $(element)
      $this.attr('tabindex', 0)
    })

    $links.on('click', event => {
      event.preventDefault();
      const $this = $(event.currentTarget)
      const index = $this.parent('li').index()
      $links.removeClass('»active')
      $this.addClass('»active')

      $slides.slick('slickGoTo', index)
    })
  })

  $('[menu]').on('click', event => {
    event.preventDefault()
    $body.toggleClass('state:menu')
  })

  $('[modal]').on('click', async e => {
    e.preventDefault();
    const $this = $(e.currentTarget)
    const url = $this.attr('href')

    const html = await $.get(url)

    $body.addClass('state:modal')
    $modal.html(html)
  })

  $('body').on('click', '[modal\\@close]', e => {
    e.preventDefault();
    $body.removeClass('state:modal')
  })


  $('[contentslider]').each((index, element) => {
    const $this = $(element)
    const $slides = $this.find('[contentslider\\@slides]')
    const $next = $this.find('[contentslider\\@next]')
    const $prev = $this.find('[contentslider\\@prev]')
    $slides.slick({
      prevArrow: $prev,
      nextArrow: $next,
      slidesToShow: 1
    })
  })

  $('[cardsslider]').each((index, element) => {
    const $this = $(element)
    const $slides = $this.find('[cardsslider\\@slides]')
    const $next = $this.find('[cardsslider\\@next]')
    const $prev = $this.find('[cardsslider\\@prev]')
    $slides.slick({
      prevArrow: $prev,
      nextArrow: $next,
      slidesToShow: 2,
      responsive: [{
        breakpoint: BREAKPOINT2,
        settings: {
          centerMode: true,
        }
      },
      {
        breakpoint: BREAKPOINT,
        settings: {
          slidesToShow: 1,
        }
      }]
    })
  })

  $('[cardswithcontentslider]').each((index, element) => {
    const $this = $(element)
    const $slides = $this.find('[cardswithcontentslider\\@slides]')
    const $next = $this.find('[cardswithcontentslider\\@next]')
    const $prev = $this.find('[cardswithcontentslider\\@prev]')

    $slides.slick({
      prevArrow: $prev,
      nextArrow: $next,
      slidesToShow: 2,
      infinite: true,
      centerMode: false, // Start with false for initial alignment
      // variableWidth: true, // Let items determine their own width
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true

        }
      },
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 2,

        }
      },
      {
        breakpoint: BREAKPOINT,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true

        }
      }]
    })
  })

  $('[newsslider]').each((index, element) => {
    const $this = $(element)
    const $slides = $this.find('[newsslider\\@slides]')
    const $next = $this.find('[newsslider\\@next]')
    const $prev = $this.find('[newsslider\\@prev]')
    $slides.slick({
      prevArrow: $prev,
      nextArrow: $next,
      slidesToShow: 1,
      responsive: [{
        breakpoint: BREAKPOINT,
        settings: {
          arrows: false,
          autoplay: true,
          autoplaySpeed: 4000,
          pauseOnHover: false,
          dots: true,
        }
      }]
    })
  })

  $('[heroslider]').each((index, element) => {
    const $this = $(element)
    const $slides = $this.find('[heroslider\\@slides]')
    const $next = $this.find('[heroslider\\@next]')
    const $prev = $this.find('[heroslider\\@prev]')
    const $dots = $this.find('[heroslider\\@dots]')

    $slides.slick({
      prevArrow: $prev,
      nextArrow: $next,
      autoplay: true,
      autoplaySpeed: 10000,
      slidesToShow: 1,
      dots: true,
      appendDots: $dots,
      dotsClass: 'slick-dots-lines'
    })
  })

  $('[stories]').each((index, element) => {
    const $this = $(element)
    const $slidesOne = $this.find('[stories\\@one]')
    const $slidesTwo = $this.find('[stories\\@two]')
    const $next = $this.find('[stories\\@next]')
    const $prev = $this.find('[stories\\@prev]')

    const random = +$this.attr('random') || false
    const initialSlide = !!random ? Math.floor(Math.random() * random) : 0;

    $slidesOne.slick({
      fade: true,
      prevArrow: $prev,
      nextArrow: $next,
      slidesToShow: 1,
      asNavFor: $slidesTwo,
      initialSlide
    })

    $slidesTwo.slick({
      prevArrow: $prev,
      nextArrow: $next,
      slidesToShow: 1,
      asNavFor: $slidesOne,
      initialSlide
    })
  })

  $('[awards-slider]').each((index, element) => {
    const $this = $(element);
    const $slides = $this.find('[awards-slider\\@slides]');
    const $next = $this.find('[awards-slider\\@next]');
    const $prev = $this.find('[awards-slider\\@prev]');

    $slides.slick({
      prevArrow: $prev,
      nextArrow: $next,
      autoplay: true,
      slidesToShow: 1,
      pauseOnHover: false,
      infinite: true,
      centerMode: false,
      slidesToScroll: 1,
    });
  });

  $('.menu-item-has-children > a').on('click', event => {
    event.preventDefault();

    const $this = $(event.currentTarget)
    const $parent = $this.parent('li.menu-item-has-children')

    if ($parent.hasClass('»active')) {
      $parent.removeClass('»active')
    } else {
      $('li.menu-item-has-children.»active').removeClass('»active')
      $parent.addClass('»active')
    }
  })


  $(document).ready(function ($) {
    // Initialize popup video functionality
    $('[popup-embed-video-trigger]').on('click', function () {
      const $modal = $(this).closest('.block\\:popup-embed-video').find('[popup-embed-video-modal]');
      const $videoContainer = $modal.find('.block\\:popup-embed-video\\:\\:video-container');

      $modal.css('display', 'flex');
      $('html,body').css('overflow', 'hidden');

      const videoId = $videoContainer.data('video-id');

      if (videoId && !$videoContainer.find('iframe').length) {
        const iframe = $('<iframe>', {
          src: `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&controls=1`,
          frameborder: 0,
          allow: 'autoplay; encrypted-media',
          allowfullscreen: true,
          css: {
            width: '100%',
            height: '100%'
          }
        });

        $videoContainer.append(iframe);
      }
    });

    // Close modal with close button
    $('[popup-embed-video-close]').on('click', function () {
      const $modal = $(this).closest('[popup-embed-video-modal]');
      const $videoContainer = $modal.find('.block\\:popup-embed-video\\:\\:video-container');

      // Pause video when closing
      $videoContainer.empty(); // Remove iframe completely

      $modal.css('display', 'none');
      $('html,body').css('overflow', '');
    });

    // Close when clicking outside content
    $('[popup-embed-video-modal]').on('click', function (e) {
      if (e.target === this) {
        const $videoContainer = $(this).find('.block\\:popup-embed-video\\:\\:video-container');
        $videoContainer.empty(); // Remove iframe completely

        $(this).css('display', 'none');
        $('html,body').css('overflow', '');

      }
    });

    // Close with Escape key
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') {
        const $iframe = $('[popup-embed-video-modal]').find('.block\\:popup-embed-video\\:\\:video-container iframe');
        $videoContainer.empty(); // Remove iframe completely

        $('[popup-embed-video-modal]').css('display', 'none');
        $('html,body').css('overflow', '');
      }
    });
  });

  // Smooth scroll to section when primary anchor is clicked
  $('.block\\:careers-nav\\:\\:primary-anchor').on('click', function (e) {
    e.preventDefault();
    const targetId = $(this).data('anchor');
    const $targetSection = $('#' + targetId);

    if ($targetSection.length) {
      $('html, body').stop().animate({
        scrollTop: $targetSection.offset().top - 100
      }, 0, 'linear');
    }
  });

})
